module.exports = __webpack_public_path__ + "img/20210117_105100.b8af0448.jpg";